"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../../../../constants");
const Root = exports.Root = (0, _mui.styled)('a')(({
  theme,
  onClick,
  href
}) => {
  const isClickable = Boolean(onClick ?? href);
  return {
    color: theme.palette.text.primary,
    cursor: isClickable ? 'pointer' : 'default',
    display: 'flex',
    height: _constants.TOP_AREA_BANNER_HEIGHT,
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    '&:hover': {
      textDecoration: isClickable ? 'underline' : 'none',
      color: theme.palette.text.primary
    }
  };
});
const Title = exports.Title = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  overflow: 'hidden',
  padding: theme.spacing(1),
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}));